module.exports = __webpack_public_path__ + "static/media/BigJohnPRO-Bold.b9af870b.woff2";